// This icon file is generated automatically.
var PUnlockOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11 5.25H3.19v-3.5c0-.48.39-.88.87-.88h3.88c.48 0 .87.4.87.88v1.06c0 .07.06.13.13.13h.87c.07 0 .13-.06.13-.13V1.75a2 2 0 00-2-2H4.06a2 2 0 00-2 2v3.5H1a.5.5 0 00-.5.5v6c0 .28.22.5.5.5h10a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zm-.63 5.88H1.63V6.37h8.75v4.75zm-4.8-2.18v.83c0 .07.05.13.12.13h.62c.07 0 .13-.06.13-.13v-.83a.75.75 0 10-.88 0z", "fill-rule": "nonzero" } }] }, "name": "p-unlock", "theme": "outlined" };
export default PUnlockOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUnlockOutlined.js
// module id = 3707
// module chunks = 0